import { Injectable, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { StatePersistenceService, StorageSyncType, WindowRef } from '@spartacus/core';
import { Subscription, fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  COMPARISON_FEATURE,
  ComparisonActions,
  ComparisonSelectors,
  ComparisonState,
  StateWithComparison,
} from './store';

@Injectable({ providedIn: 'root' })
export class ComparisonPersistenceService implements OnDestroy {
  private subscription = new Subscription();

  constructor(
    private statePersistenceService: StatePersistenceService,
    private store: Store<StateWithComparison>,
    private windowRef: WindowRef,
  ) {}

  sync(): void {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: COMPARISON_FEATURE,
        state$: this.store.pipe(select(ComparisonSelectors.getComparisonFeatureState)),
        storageType: StorageSyncType.LOCAL_STORAGE,
        onRead: (state) => this.onRead(state),
      }),
    );

    this.subscription.add(
      fromEvent(this.windowRef.document, 'visibilitychange').subscribe(() => {
        if (this.windowRef.document.visibilityState === 'visible') {
          const storageState = this.statePersistenceService.readStateFromStorage<ComparisonState>({
            key: COMPARISON_FEATURE,
          });
          const state$ = this.store.pipe(select(ComparisonSelectors.getComparisonFeatureState));
          state$.pipe(take(1)).subscribe((state: ComparisonState) => {
            if (JSON.stringify(state) !== JSON.stringify(storageState)) {
              this.store.dispatch(new ComparisonActions.ComparisonSetState(state));
            }
          });
        }
      }),
    );
  }

  onRead(state: ComparisonState): void {
    if (state) {
      this.store.dispatch(new ComparisonActions.ComparisonSetState(state));
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
